import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from "react";
import { MDXProvider, withMDXComponents } from "@mdx-js/react";
import { MDXScopeProvider } from "./context";

/**
 * so, this import is weird right?
 *
 * # What it looks like:
 * we're importing a webpack loader directly into our runtime bundle
 *
 * # What it's actually doing:
 * We configure the `mdx-components` loader in gatsby-node's
 * `onCreateWebpackConfig`. The configuration sets the loader to handle its
 * own file, so if we import `./loaders/mdx-components`, the `mdx-components`
 * loader handles loading itself.
 *
 * # Why does this work?
 * The loader doesn't use the file argument to itself and instead returns
 * a generated file that includes the `gatsby-config` mdxPlugins wrapped in
 * require() statements. This results in the `mdxPlugins` being required
 * and available to the code after this import.
 *
 * # Have a better solution to this?
 * Submit a PR
 */
import { plugins as mdxPlugins } from "./loaders/mdx-components";
import scopeContexts from "./loaders/mdx-scopes";
import { jsx as ___EmotionJSX } from "@emotion/core";
const componentsAndGuards = {};
const componentFromGuards = arr => function GatsbyMDXComponentFinder(props) {
  const {
    Component
  } = arr.find(_ref => {
    let {
      guard
    } = _ref;
    return guard ? guard(props) : true;
  });
  return ___EmotionJSX(Component, props);
};
mdxPlugins.forEach(_ref2 => {
  let {
    guards = {},
    components
  } = _ref2;
  Object.entries(components).forEach(_ref3 => {
    let [componentName, Component] = _ref3;
    if (componentsAndGuards[componentName]) {
      componentsAndGuards.push({
        guard: guards[componentName],
        Component
      });
    } else {
      componentsAndGuards[componentName] = [{
        guard: guards[componentName],
        Component
      }];
    }
  });
});
const components = Object.entries(componentsAndGuards).map(_ref4 => {
  let [name, arr] = _ref4;
  return {
    [name]: componentFromGuards(arr.concat({
      guard: undefined,
      Component: name
    }))
  };
}).reduce((acc, obj) => {
  return _objectSpread(_objectSpread({}, acc), obj);
}, {});

// merge any components in wrapRootElement above this wrapRoot
const MDXConsumer = withMDXComponents(_ref5 => {
  let {
    components: componentsFromContext,
    children
  } = _ref5;
  return ___EmotionJSX(MDXScopeProvider, {
    __mdxScope: scopeContexts
  }, ___EmotionJSX(MDXProvider, {
    components: _objectSpread(_objectSpread({}, componentsFromContext), components)
  }, children));
});
const WrapRootElement = _ref6 => {
  let {
    element
  } = _ref6;
  return ___EmotionJSX(MDXConsumer, null, element);
};
export default WrapRootElement;
if (typeof WrapRootElement !== 'undefined' && WrapRootElement && WrapRootElement === Object(WrapRootElement) && Object.isExtensible(WrapRootElement) && !Object.prototype.hasOwnProperty.call(WrapRootElement, '__filemeta')) {
  Object.defineProperty(WrapRootElement, '__filemeta', {
    configurable: true,
    value: {
      name: "WrapRootElement",
      filename: "node_modules/gatsby-plugin-mdx/wrap-root-element.js"
    }
  });
}